import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

interface ExpandedScholarshipProps {
  scholarship: string;
  financialAid?: string;
}

const useStyles = makeStyles(() => ({
  financialAidTitle: {
    color: "#231F20",
    fontSize: 12,
  },
  content: {
    fontSize: 12,
  },
  container: {
    marginTop: 10,
  },
}));

export const ExpandedScholarship: FC<ExpandedScholarshipProps> = ({
  scholarship,
  financialAid,
}) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.content}>{scholarship}</div>
      {financialAid && (
        <div className={classes.container}>
          <div className={classes.financialAidTitle}>Financial AID</div>
          <div className={classes.content}>{financialAid}</div>
        </div>
      )}
    </div>
  );
};
